<template>
  <BaseContainer>
    <v-content
      class="main-container"
      slot="principal"
    >
      <v-container>
        <PricingSection />

        <TestimonialsCarousel class="section" />

        <v-divider class="mt-6"/>

        <Footer class="section" />
      </v-container>
    </v-content>
  </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer.vue';
import Footer from '@/components/Footer.vue';
import PricingSection from '@/components/PricingSection.vue';
import TestimonialsCarousel from '@/components/TestimonialsCarousel.vue';

export default {
  name: 'Home',

  components: {
    BaseContainer,
    Footer,
    PricingSection,
    TestimonialsCarousel,
  },

  data: () => ({
  }),

  mounted() {
  },

  computed: {
  },

  methods: {
  },
};
</script>

<style scoped lang="scss">
.main-container {
  margin: 30px 3% 0 3%;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  list-style: none;
}

.section {
  margin-top: 30px;
}
</style>
